import StorybookHero from "@/components/storybook/StorybookHero";
import BookDetailsSection from "@/components/storybook/BookDetailsSection";
import HeroesFromBookSection from "@/components/storybook/HeroesFromBookSection";
import ChapterPreviewSection from "@/components/storybook/ChapterPreviewSection";
import NotifySection from "@/components/storybook/NotifySection";

export default function StorybookPage() {
  return (
    <div data-testid="storybook-page">
      <StorybookHero />
      <BookDetailsSection />
      <HeroesFromBookSection />
      <ChapterPreviewSection />
      <NotifySection />
    </div>
  );
}
